import Vue from 'vue'
import Vuex from 'vuex'
import { paidAgentTextsApi } from '@/apis/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 在这里定义你的状态
    chatItems: [],
    chatIdSelected: null,
    merchantGuid: localStorage.getItem('merchantGuid') || '',
    // merchantGuid: '',
    userGuid: localStorage.getItem('userGuid') || '',
    shareText: {
      noMemberTip: "", //付费智能体未开通会员提示
      noMemberSlogan: "", //付费智能体未开通会员slogo
      hasMemberTip: "", //付费智能体已开通会员后提示
      hasMemberSlogan: "", //付费智能体已开通会员slogo
      subscribeNotice: "", //付费智能体订阅须知文案
      miniprogramShareText: "", //付费智能体小程序分享文案
      promotionRules: "" //付费智能体推广规则文案
    }
  },
  mutations: {
    // 在这里定义如何修改你的状态
    setMerchantGuid(state, merchantGuid) {
      state.merchantGuid = merchantGuid;
      localStorage.setItem('merchantGuid', merchantGuid);
    },
    setUserGuid(state, userGuid) {
      state.userGuid = userGuid;
      localStorage.setItem('userGuid', userGuid);
    },
    clearMerchantGuid(state) {
      state.merchantGuid = '';
      localStorage.removeItem('merchantGuid');
    }
  },
  actions: {
    // 在这里定义异步操作

  },
  getters: {
    chatItemSelected: state => {
      return state.chatItems.find(item => item.id === state.chatIdSelected);
    },
  }
})
